import { kitsRoutes } from './kits/routes';
import { catalogPublicRoutes } from '../extensions/catalog/catalogPublicRoutes';
import { authRoutes } from './auth/routes';
import { homeRoutes } from './home/routes';
import { usersRoutes } from './users/routes';
import { customersRoutes } from './customers/routes';
import { productsRoutes } from './products/routes';
import { categoriesRoutes } from './categories/routes';
import { mediasRoutes } from './medias/routes';
import { ordersRoutes } from './orders/routes';
import { settingsRoutes } from './settings/routes';
import { adminRoutes } from './admin/routes';

export const appModuleRoutes = [
  ...catalogPublicRoutes,
  ...kitsRoutes,
  ...authRoutes,
  ...homeRoutes,
  ...usersRoutes,
  ...customersRoutes,
  ...categoriesRoutes,
  ...productsRoutes,
  ...mediasRoutes,
  ...ordersRoutes,
  ...settingsRoutes,
  ...adminRoutes,
];
